import React from "react";

/** Decorative brand doodles — always aria-hidden. */

export const DoodleHeart = ({ className = "", size = 28 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M16 27s-9-5.8-12.5-11C1.2 12.5 2.5 7.5 7 6.2c2.5-.7 5 .3 6.5 2.3C15 6.5 17.5 5.5 20 6.2c4.5 1.3 5.8 6.3 3.5 9.8C25 21.2 16 27 16 27z"
      stroke="var(--color-heart-teal)"
      strokeWidth="1.75"
      strokeLinejoin="round"
    />
  </svg>
);

export const DoodleStar = ({ className = "", size = 28 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M16 3.5l3.2 9.1H29l-7.4 5.6 2.8 9.1L16 22.5l-8.4 4.8 2.8-9.1L3 12.6h9.8L16 3.5z"
      stroke="var(--color-sunshine)"
      strokeWidth="1.75"
      strokeLinejoin="round"
    />
  </svg>
);

export const DoodleCloud = ({ className = "", size = 36 }) => (
  <svg
    width={size}
    height={size * 0.65}
    viewBox="0 0 48 32"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M12 26h26a8 8 0 0 0 0-16 10 10 0 0 0-19.2-2.5A7.5 7.5 0 0 0 12 26z"
      stroke="var(--color-sky-blue)"
      strokeWidth="1.75"
      fill="var(--color-cloud-mist)"
      fillOpacity="0.5"
    />
  </svg>
);

/** Solid Spectrum Blue rounded square (12px-feel corners) — Brand Guidelines graphic elements */
export const DoodleRoundedSquare = ({ className = "", size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <rect
      x="2"
      y="2"
      width="28"
      height="28"
      rx="6"
      fill="var(--color-spectrum-blue)"
    />
  </svg>
);

export const DoodleSparkle = ({ className = "", size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M12 2v6M12 16v6M2 12h6M16 12h6"
      stroke="var(--color-sunshine)"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
  </svg>
);

export const WatercolourWash = ({
  className = "",
  variant = "mist",
}) => {
  const fills = {
    mist: "var(--color-cloud-mist)",
    sky: "var(--color-sky-blue)",
    sunshine: "var(--color-sunshine)",
    teal: "var(--color-heart-teal)",
  };
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      style={{
        background: `
          radial-gradient(ellipse 80% 60% at 10% 20%, ${fills[variant]} 0%, transparent 55%),
          radial-gradient(ellipse 60% 50% at 90% 80%, ${fills.mist} 0%, transparent 50%)
        `,
        opacity: variant === "mist" ? 1 : 0.35,
      }}
    />
  );
};
